// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import dayjs from 'dayjs';
import Loading from 'Common/Components/Loading';
import { useInstantToken } from 'Account/hooks/account';
import { useQueryClient } from '@tanstack/react-query';
import { useLocalStorageState } from 'ahooks';
import { AccountPersistInfo } from 'Internal.CommonAPI';
import { useCommonInfo } from 'Common/hooks/info';

const InstantLogin: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [_, setAccount] = useLocalStorageState<AccountPersistInfo>('account');
  const navigateToHome = useCallback(() => navigate('/'), [navigate]);
  const params = new URLSearchParams(location.search);
  const token = params.get('token');
  const commonApiInfoQuery = useCommonInfo(token ?? undefined);

  useEffect(() => {
    queryClient.removeQueries();
    commonApiInfoQuery.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (token) {
      setAccount(
        (prev) =>
          ({
            ...prev,
            userSuccessful: true,
            tokenSetAt: dayjs().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            userToken: token,
          }) as AccountPersistInfo
      );
      queryClient.setQueryData(['account', 'userToken'], token);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { isSuccess, isLoading, isError } = useInstantToken(token || undefined);

  useEffect(() => {
    if (isSuccess) {
      navigateToHome();
    }
    if (isError) {
      navigate('/login');
    }
  }, [isSuccess, isError, navigate, navigateToHome]);

  if (isLoading) {
    return (
      <div style={{ margin: '100px' }}>
        <Loading
          text="We're validating the credentials provided"
          color="rgba(0,0,0,.65)"
        />
      </div>
    );
  }
  return null;
};

export default InstantLogin;
